import { styled, Theme } from "@mui/material";
import Badge, { BadgeProps } from "@mui/material/Badge";
import { ShippingBoxV1 as Box } from "akar-icons";
import React from "react";
import { ICustomerPortalTheme } from "../../entities/CustomerPortalTheme";

interface IQtyProps extends BadgeProps {
  quantity: number;
  theme?: Theme & ICustomerPortalTheme;
}

const Dot = styled(Badge)<IQtyProps>`
  align-items: center;
  background-color: ${props => props.theme.modernIconsColor};
  border-radius: 40px;
  color: ${props => props.theme.modernPageBackground};
  display: flex;
  font-size: 12px;
  font-weight: 400;
  height: 20px;
  justify-content: center;
  left: -5px;
  min-width: 20px;
  padding: 0px ${props => (props.quantity ? "4px" : "0px")};
  position: absolute;
  stroke: ${props => props.theme.modernPageBackground};
  top: -5px;
  width: max-content;
  z-index: 1;
`;

export const QtyBlip = ({ quantity, ...props }: IQtyProps): React.JSX.Element => {
  return (
    <Dot {...props} quantity={quantity}>
      {quantity < 1 ? <Box size="16px" stroke="1px" strokeWidth="1.25px" /> : quantity}
    </Dot>
  );
};
